var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileMenuIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.52979 12.709C7.69027 12.8031 7.86182 12.8501 8.04443 12.8501H21.9561C22.1442 12.8501 22.3185 12.8031 22.479 12.709C22.6395 12.6094 22.7668 12.4793 22.8608 12.3188C22.9604 12.1528 23.0103 11.973 23.0103 11.7793C23.0103 11.5856 22.9604 11.4085 22.8608 11.248C22.7668 11.0876 22.6395 10.9603 22.479 10.8662C22.3185 10.7666 22.1442 10.7168 21.9561 10.7168H8.04443C7.86182 10.7168 7.69027 10.7666 7.52979 10.8662C7.3693 10.9603 7.23926 11.0876 7.13965 11.248C7.04004 11.4085 6.99023 11.5856 6.99023 11.7793C6.99023 11.973 7.04004 12.1528 7.13965 12.3188C7.23926 12.4793 7.3693 12.6094 7.52979 12.709Z",
    fill: "#1E1542"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.52979 19.142C7.69027 19.2361 7.86182 19.2831 8.04443 19.2831H21.9561C22.1442 19.2831 22.3185 19.2361 22.479 19.142C22.6395 19.0424 22.7668 18.9123 22.8608 18.7518C22.9604 18.5858 23.0103 18.406 23.0103 18.2123C23.0103 18.0186 22.9604 17.8415 22.8608 17.681C22.7668 17.5206 22.6395 17.3933 22.479 17.2992C22.3185 17.1996 22.1442 17.1498 21.9561 17.1498H8.04443C7.86182 17.1498 7.69027 17.1996 7.52979 17.2992C7.3693 17.3933 7.23926 17.5206 7.13965 17.681C7.04004 17.8415 6.99023 18.0186 6.99023 18.2123C6.99023 18.406 7.04004 18.5858 7.13965 18.7518C7.23926 18.9123 7.3693 19.0424 7.52979 19.142Z",
    fill: "#1E1542"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileMenuIcon);
export default __webpack_public_path__ + "static/media/mobileMenuIcon.733cef893f2fc1df89bbafe74f3e6ff3.svg";
export { ForwardRef as ReactComponent };